import { render, staticRenderFns } from "./linkModal.vue?vue&type=template&id=88bb4818&scoped=true&"
import script from "./linkModal.vue?vue&type=script&lang=js&"
export * from "./linkModal.vue?vue&type=script&lang=js&"
import style0 from "./linkModal.vue?vue&type=style&index=0&id=88bb4818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bb4818",
  null
  
)

export default component.exports